const SESSION_KEY = 'kidsParentsApp_cognitoSession'
const FAMILY_DATA_LEGACY_KEY = 'kidsParentsApp_familyData'
// Mock-data mode has no Cognito tokens, so it keeps its own tiny session
// (just the phone number) to survive a page refresh.
const MOCK_SESSION_KEY = 'kidsParentsApp_mockSession'

export function loadSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    console.warn('Failed to load Cognito session:', error)
    return null
  }
}

export function saveSession(session) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  } catch (error) {
    console.warn('Failed to save Cognito session:', error)
  }
}

export function clearLegacyFamilyData() {
  try {
    localStorage.removeItem(FAMILY_DATA_LEGACY_KEY)
  } catch (error) {
    console.warn('Failed to clear legacy family cache:', error)
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_KEY)
    localStorage.removeItem(FAMILY_DATA_LEGACY_KEY)
    localStorage.removeItem(MOCK_SESSION_KEY)
  } catch (error) {
    console.warn('Failed to clear Cognito session:', error)
  }
}

export function loadMockSession() {
  try {
    const raw = localStorage.getItem(MOCK_SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    console.warn('Failed to load mock session:', error)
    return null
  }
}

export function saveMockSession(session) {
  try {
    localStorage.setItem(MOCK_SESSION_KEY, JSON.stringify(session))
  } catch (error) {
    console.warn('Failed to save mock session:', error)
  }
}

export function sessionFromAuthResult(result) {
  const expiresIn = Number(result?.ExpiresIn || 1800)
  return {
    accessToken: result.AccessToken,
    idToken: result.IdToken,
    refreshToken: result.RefreshToken,
    expiresAt: Date.now() + expiresIn * 1000,
  }
}

export function mergeRefreshedSession(previous, result) {
  const next = sessionFromAuthResult(result)
  return {
    accessToken: next.accessToken,
    idToken: next.idToken || previous?.idToken,
    refreshToken: next.refreshToken || previous?.refreshToken,
    expiresAt: next.expiresAt,
  }
}
